import React, { useContext  } from 'react';
import { Typography, Box, Stack, IconButton, Icon, Button } from '@mui/material';
import dayjs from 'dayjs';
import TableChartIcon from '@mui/icons-material/TableChart';
import {exportToExcel} from '../../util/excel'
import userContext from '../../context/userContext';
const BookRow = ({row}) =>{
    return (
        <Stack sx={{ml: 1, width: '100%'}} direction="row">
            <Box sx={{width: '30%'}}>
                <Typography>{row.tenant.name}</Typography>
            </Box>
            <Box  sx={{width: '20%'}}>
                <Typography>{row.totalHours} hr</Typography>
            </Box>
            <Box  sx={{width: '20%'}}>
                <Typography>₹ {row.amount}</Typography>
            </Box>
            <Box  sx={{width: '20%'}}>
                <Typography sx={{fontSize: '12px'}}>{dayjs(row.from).format('HH:mm')} - {dayjs(row.to).format('HH:mm')}</Typography>
            </Box>
        </Stack>
    )
}

const TotalRow = ({aggregatedHours, aggregatedAmount}) => {
    return (
        <Stack sx={{ml: 1, width: '100%', mt: 2, pt: 2, borderTop: '1px solid black'}} direction="row">
            <Box sx={{width: '30%'}}>
                Total
            </Box>
            <Box  sx={{width: '20%'}}>
                <Typography>{aggregatedHours} hr</Typography>
            </Box>
            <Box  sx={{width: '20%'}}>
                <Typography>₹ {aggregatedAmount}</Typography>
            </Box>
            <Box  sx={{width: '20%'}}>
                
            </Box>
        </Stack>
    )
}

const BookDay = ({data}) => {
    if (Array.isArray(data.bookings) && data.bookings.length > 0) { 
        return (
            <Box sx={{mb: 1}}>
                <Typography sx={{fontWeight: 'bold'}}>{data.date}</Typography>
                {data.bookings.map(datum => <BookRow row={datum}/>)}
            </Box>
        )
    }
    return null
}
const BookingTable = ({bookings}) => {
    
    const { user } = useContext(userContext);
    const {aggregateHours, aggregateAmount} = bookings.reduce((acc, curr) => {
        acc.aggregateAmount += (curr.aggregatedAmount || 0)
        acc.aggregateHours  += (curr.hoursOccupied || 0)
        return acc
    }, {aggregateAmount: 0, aggregateHours: 0})
    
    return (
        <Box  sx={{ pl: 2, pr: 2 }}>
            <Stack direction="row" alignItems="center" sx={{mb:2}} justifyContent="space-between">
                <Typography sx={{fontWeight: 'bold', fontSize: '1.2rem'}}>Bookings</Typography>
                <Stack alignItems="center">
                    <Button size="small" variant="contained" onClick={()=>{exportToExcel(bookings, aggregateHours, aggregateAmount, user.user.turfName)}}>
                        <Stack direction="column" alignItems="center"><TableChartIcon/> <Typography sx={{fontSize: '8px'}}>Excel</Typography></Stack>
                    </Button>
                    
                </Stack>
            </Stack>
            <Box sx={{maxHeight: '20vh', overflowY: 'scroll', overflowX: 'hidden'}}>
                {bookings.map(book => <BookDay key={`box-${book.date}`} data={book}/>)}
            </Box>
            <Box>
                <TotalRow aggregatedHours={aggregateHours} aggregatedAmount={aggregateAmount}/>
            </Box>
        </Box>        
    )
}

export default BookingTable;